<template>
  <div class="open-page">
    <childNav
      :routerName="$t('breadcrumbItem.data')"
      :backFlag="true"
    ></childNav>
    <div class="open-body">
      <div class="open-box">
        <Form
          ref="addForm"
          :label-width="enFlag ? 200 : 130"
          :model="addForm"
          label-colon
          :rules="ruleValidate"
        >
          <FormItem :label="$t('openConfig.version')" prop="version">
            <Select
              v-model="addForm.version"
              class="select-width"
              size="large"
              clearable
              :placeholder="$t('openConfig.versionTip')"
            >
              <Option
                v-for="(item, index) in versionList"
                :key="index"
                :value="item"
                >{{ item }}</Option
              >
            </Select>
          </FormItem>

          <FormItem :label="$t('openConfig.signType')" prop="signType">
            <RadioGroup v-model="addForm.signType">
              <Radio
                v-for="(item, index) in signList"
                :label="item.value"
                :key="index"
                size="large"
              >
                <span>{{ item.label }}</span>
              </Radio>
            </RadioGroup>
          </FormItem>

          <FormItem :label="$t('openConfig.fileLabel')">
            <span slot="label">
              <span class="error-color">*</span>
              {{ $t("openConfig.fileLabel") }}
            </span>
            <form id="uploadImg">
              <div class="form-box">
                <Button type="primary" class="file upload-btn">
                  <Icon type="md-add" class="add-icon" />
                  {{ $t("openConfig.addFile") }}
                  <input
                    type="file"
                    name="facePic"
                    multiple
                    @change="showPic($event)"
                  />
                </Button>
              </div>
            </form>
          </FormItem>
          <div v-if="hasList">
            <Table
              :columns="columns12"
              stripe
              border
              tooltip-theme="light"
              :data="dataList"
              height="360"
            >
              <template slot="confType" slot-scope="{ row, index }">
                <RadioGroup
                  v-model="row.confType"
                  @on-change="changeConf(row, index)"
                >
                  <Radio
                    v-for="(item, index) in confList"
                    :label="item.value"
                    :key="index"
                    class="radio-margin"
                  >
                    <span>{{ item.label }}</span>
                  </Radio>
                </RadioGroup>
              </template>
              <template slot="zipType" slot-scope="{ row, index }">
                <RadioGroup
                  v-model="row.zipType"
                  @on-change="changeZip(row, index)"
                >
                  <Radio
                    v-for="(item, index) in zipList"
                    :label="item.value"
                    :key="index"
                    class="radio-margin"
                  >
                    <span>{{ item.label }}</span>
                  </Radio>
                </RadioGroup>
              </template>
              <template slot="action" slot-scope="{ row, index }">
                <Button type="error" @click="delFile(index)">{{
                  $t("common.delete")
                }}</Button>
              </template>
            </Table>
          </div>
          <div v-else class="noList-box" :class="{ 'red-border': checkFile }">
            <img src="../../assets/image/nodata-icon.png" class="img-table" />
            <span>{{ $t("openConfig.noFile") }}</span>
          </div>
          <span class="require-tip" v-if="checkFile">{{
            $t("openConfig.checkFile")
          }}</span>
          <div v-if="!checkFile" class="tip-height"></div>
        </Form>
        <div class="bottom-btn">
          <Button
            ghost
            size="large"
            type="primary"
            class="btn-width"
            @click="resetForm"
            >{{ $t("openConfig.reset") }}</Button
          >
          <Button
            size="large"
            type="primary"
            class="btn-width"
            :loading="loading"
            @click="submitForm"
            >{{ $t("openConfig.pack") }}</Button
          >
        </div>
      </div>
    </div>
    <div class="content_win"></div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import childNav from "@/components/homeNav/childNav.vue";
export default {
  name: "openList",
  components: {
    childNav,
  },
  data() {
    return {
      focusPage: "2",
      addForm: {
        version: "1.0.0",
        signType: "1",
      },
      ruleValidate: {
        version: [
          {
            required: true,
            message: this.$t("openConfig.checkVersion"),
            trigger: "blur",
          },
        ],
        signType: [
          {
            required: true,
            message: this.$t("openConfig.checkSignType"),
            trigger: "blur",
          },
        ],
      },
      versionList: ["1.0.0"],
      signList: [{ label: "MD5", value: "1" }],
      // 压缩方式 N：未进行压缩 Z: zip
      zipList: [
        { label: "Gzip", value: "GZ" },
        { label: this.$t("openConfig.noZip"), value: "N" },
      ],
      // 配置类型 TEST,NAME_LIST
      confList: [
        // { label: "TEST", value: "TEST" },
        { label: "NAME_LIST", value: "NAME_LIST" },
      ],
      columns12: [
        {
          title: this.$t("openConfig.fileName"),
          align: "center",
          key: "fileName",
        },

        {
          title: this.$t("openConfig.confType"),
          slot: "confType",
          align: "center",
          width: 230,
        },

        {
          title: this.$t("openConfig.zipType"),
          slot: "zipType",
          align: "center",
          width: 200,
        },
        {
          title: this.$t("common.action"),
          slot: "action",
          align: "center",
          width: 100,
        },
      ],
      dataList: [],
      hasList: false,
      checkFile: false,
      loading: false,
    };
  },
  watch: {
    dataList: {
      handler() {
        if (this.dataList.length > 0) {
          this.hasList = true;
          this.checkFile = false;
        } else {
          this.hasList = false;
        }
      },
    },
  },
  mounted() {},
  methods: {
    showPic($event) {
      let el = $event.currentTarget;
      if (el.files.length > 0) {
        for (let i = 0; i < el.files.length; i++) {
          let obj = {
            zipType: "N",
            confType: "NAME_LIST",

            fileName: el.files[i].name,
            file: el.files[i],
          };
          this.dataList.push(obj);
        }
      }
      this.hasList = true;
      this.$forceUpdate();
    },
    // 删除文件
    delFile(index) {
      this.dataList.splice(index, 1);
    },
    // 改变压缩方式
    changeZip(row, index) {
      this.dataList[index].zipType = row.zipType;
    },
    // 改变配置类型
    changeConf(row, index) {
      this.dataList[index].confType = row.confType;
    },
    //  提交表单
    submitForm() {
      let flag1 = false;
      let flag2 = false;
      if (this.dataList.length > 0) {
        //  没选择文件
        flag1 = true;
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          flag2 = true;
        }
      });

      if (flag1 && flag2) {
        // 通过校验
        this.add();
      } else if (!flag1) {
        this.checkFile = true;
      }
    },
    // 提交
    add() {
      this.loading = true;
      let packDefinition = {
        version: this.addForm.version,
        confDefinitions: [],
      };
      // 签名方式
      if (Number(this.addForm.signType) === 1) {
        packDefinition.signMethod = "MD5";
      }
      let formData = new FormData();
      this.dataList.map((i, k) => {
        let obj = {
          cmd: i.confType,
          idx: k,
          reduce: i.zipType,
        };
        packDefinition.confDefinitions.push(obj);
        formData.append("configs", i.file);
      });

      formData.append("packDefinition", JSON.stringify(packDefinition));
      let _this = this;
      this.$axios({
        method: "post",
        url: "/device-service/config/pack",
        data: formData,
        responseType: "blob",
      })
        .then((response) => {
          const res = response;
          let data = res.data;
          console.log(res);
          console.log(data);
          debugger;
          let fileReader = new FileReader();
          fileReader.onload = function () {
            try {
              let jsonData = JSON.parse(this.result);

              if (jsonData.statusCode === 500 && jsonData.success === false) {
                // 说明是普通对象数据，后台转换失败
                // to do something
                _this.$Message.error(jsonData.message);
                _this.loading = false;
              } else {
                return false;
              }
            } catch (err) {
              _this.loading = false;
              // 解析成对象失败，说明是正常的文件流
              _this.downLoadFile(res.data);
            }
          };
          fileReader.readAsText(res.data);
        })
        .catch(() => {});
    },
    downLoadFile(file) {
      let newDate = new Date();
      let year = newDate.getFullYear() + "";
      let month = newDate.getMonth() + 1 + "";
      let day = newDate.getDate();
      day = Number(day) > 10 ? day + "" : "0" + day;
      let fileName = year + month + day + "pack.cnf";

      let blob = new Blob([file]);
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.href = href;

      downloadElement.download = fileName; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    },
    resetForm() {
      this.dataList = [];
      this.addForm = {
        version: "1.0.0",
        signType: "1",
      };
      this.checkFile = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.open-page {
  .open-body {
    .open-box {
      height: 750px;
      padding: 80px 60px;

      .bottom-btn {
        margin-top: 20px;
      }
      .required-span {
        left: 30%;
      }
      .require-spanEn {
        left: 32%;
      }

      .form-box {
        .upload-btn {
          margin-bottom: 10px;
        }
      }
      .radio-margin {
        margin-right: 10px;
      }
    }
  }
}
</style>
